import { CATEGORY } from 'modules/analytics-provider/analytics-provider.constants';

export const AGE_RATINGS_COUNTRY_RULES = {
    PEGI: [],
    USK: ['DE'],
    ESRB: [
        'US',
        'CA',
        'MX',
        'AI',
        'AR',
        'AW',
        'BS',
        'BB',
        'BZ',
        'BM',
        'BO',
        'CL',
        'CO',
        'CR',
        'CU',
        'CW',
        'DM',
        'DO',
        'EC',
        'SV',
        'GT',
        'GY',
        'HT',
        'HN',
        'JM',
        'NI',
        'PA',
        'PY',
        'PE',
        'PR',
        'KN',
        'LC',
        'VC',
        'SR',
        'TT',
        'UY',
        'VE'
    ],
    DJCTQ: ['BR'],
    ACB: ['AU'],
    OFLC: ['NZ'],
    RARS: ['RU'],
    CERO: ['JP'],
    GRAC: ['KR'],
    GSRR: ['TW']
};
export const ESRB_PRIVACY_RULES = ['ESRB', 'DJCTQ'];
export const DEFAULT_FALLBACK_RATING = 'PEGI';
export const ESRB_PRIVACY_LINK = 'http://www.esrb.org/confirm/ubisoft-confirmation.aspx';
export const AGE_RATINGS_LINKS = {
    PEGI: 'https://pegi.info',
    USK: 'http://www.usk.de',
    ESRB: 'http://www.esrb.org/ratings/ratings_guide.aspx',
    DJCTQ: 'http://culturadigital.br/classind/ ',
    ACB: 'http://www.classification.gov.au',
    OFLC: 'https://www.classificationoffice.govt.nz/',
    RARS: null,
    CERO: 'http://www.cero.gr.jp/',
    GRAC: 'http://www.grac.or.kr',
    GSRR: 'http://www.gamerating.org.tw/'
};

export const AGE_RAITING_FLOW_ACTION = {
    location: 'footer',
    category: CATEGORY.ACTION,
    action: 'age rating'
};
